import _ from "lodash";
import axios from "axios";
import { canaveral_url } from "..";
import { source_entity } from "../../context";

const website_api_key = import.meta.env.VITE_APP_WEBSITE_KEY;

export const storeSearchSessionMetadata = async ({
  service_type,
  user_id = null,
  session_data,
}) => {
  try {
    const response = await axios.post(`${canaveral_url}/search-session-metadata/`, {
      source_entity,
      website_api_key,
      service_type,
      user_id,
      session_data: { data: session_data },
    });

    return _.get(response, "data", {});
  } catch {
    return null;
  }
};

export const retrieveSearchSessionMetadata = async ({ page_session_id }) => {
  try {
    const response = await axios.get(`${canaveral_url}/search-session-metadata/${page_session_id}`);
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const retrSearchSessionMetadata = async ({ page_session_id }) => {
  return axios.get(`${canaveral_url}/search-session-metadata/${page_session_id}`);
};
